"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Sbp = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Sbp = function Sbp(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SBP_svg__SBP_svg__clip0_20336_109078)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SBP_svg__SBP_svg__clip1_20336_109078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.75 17.16v5.49h-1.852v-3.852h-1.783v3.852h-1.852v-5.49h5.487zm-6.362 3.06c0 1.596-1.273 2.651-2.99 2.651-1.776 0-3.068-1.116-3.068-3.647 0-2.17 1.326-3.958 3.293-3.99.858 0 2.707-.042 2.707-.042l-.832 1.596h-1.667a1.706 1.706 0 00-1.145.451 1.85 1.85 0 00-.58 1.125 2.465 2.465 0 011.773-.696c1.565.003 2.51 1.006 2.51 2.552zm-1.9 0c0-.717-.443-1.136-1.079-1.136-.658 0-1.097.429-1.097 1.146 0 .675.441 1.168 1.097 1.168.682 0 1.075-.533 1.075-1.178h.004zm-5.628.772a2.79 2.79 0 01-1.117.313c-.768.024-1.448-.47-1.448-1.35 0-.88.605-1.351 1.434-1.351.508 0 1.185.36 1.185.36s.493-.923.747-1.384a2.914 2.914 0 00-1.82-.557c-1.826 0-3.239 1.216-3.239 2.923 0 1.73 1.329 2.917 3.239 2.881.534-.02 1.272-.212 1.72-.506l-.7-1.33z",
    fill: "#161F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 13.789l2.56 4.762v2.903l-2.556 4.753L1.25 13.79z",
    fill: "#656CAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.074 16.818l2.399-1.53 4.904-.004-7.303 4.66v-3.126z",
    fill: "#C25169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.061 13.761l.013 6.304-2.564-1.64V9l2.551 4.761z",
    fill: "#EBAD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.377 15.284l-4.904.004-2.412-1.527L8.51 9l9.867 6.284z",
    fill: "#DB754B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.074 26.235v-3.06l-2.564-1.61V31l2.563-4.765z",
    fill: "#81BB5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.466 24.719L3.809 18.55 1.25 13.79l17.118 10.924-4.902.006z",
    fill: "#608BC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.511 31l2.563-4.765 2.392-1.516 4.902-.006L8.511 31z",
    fill: "#548254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.254 26.207l7.275-4.642-2.445-1.562-2.275 1.451-2.555 4.753z",
    fill: "#8366A8"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SBP_svg__SBP_svg__clip0_20336_109078"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SBP_svg__SBP_svg__clip1_20336_109078"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-4 9)",
    d: "M0 0h48v22H0z"
  }))));
};

exports.Sbp = Sbp;
var _default = Sbp;
exports.default = _default;